module.exports = {
  memphis: {
    name: 'Memphis',
    address: '3588 Paul R Lowry Road, Memphis, TN 38109',
    lat: 35.0449622,
    lng: -90.1555276,
    coords: { lat: 35.0449622, lng: -90.1555276 },
    prices: [
      { start: 0, end: 10, min: 295, rpm: 36.2 },
      { start: 11, end: 20, min: 363, rpm: 24 },
      { start: 21, end: 30, min: 481, rpm: 16.9 },
      { start: 31, end: 40, min: 508, rpm: 13.6 },
      { start: 41, end: 50, min: 545, rpm: 11.4 },
      { start: 51, end: 70, min: 572, rpm: 10.1 },
      { start: 71, end: 90, min: 604, rpm: 7 },
      { start: 91, end: 110, min: 631, rpm: 6.8 },
      { start: 111, end: 130, min: 744, rpm: 6.5 },
      { start: 131, end: 150, min: 849, rpm: 6.4 },
      { start: 151, end: 200, min: 964, rpm: 5.8 },
      { start: 201, end: 250, min: 1157, rpm: 5.4 },
      { start: 251, end: 300, min: 1350, rpm: 4.8 },
      { start: 301, end: 350, min: 1447, rpm: 4.7 },
      { start: 351, end: 400, min: 1640, rpm: 4.6 },
      { start: 401, end: 450, min: 1832, rpm: 4.3 },
      { start: 451, end: 500, min: 1929, rpm: 4 },
      { start: 500, end: 99999, min: 2025, rpm: 4 },
    ],
  },
  losangeles: {
    name: 'Los Angeles',
    address: '415 W. Ocean Blvd, Long Beach, CA 90802',
    lat: 33.7541833,
    lng: -118.2339676,
    coords: { lat: 33.7541833, lng: -118.2339676 },
    prices: [
      { start: 0, end: 10, min: 263.25, rpm: 32.3 },
      { start: 11, end: 20, min: 324, rpm: 21.5 },
      { start: 21, end: 30, min: 530, rpm: 18.6 },
      { start: 31, end: 40, min: 560, rpm: 15 },
      { start: 41, end: 50, min: 600, rpm: 12.6 },
      { start: 51, end: 70, min: 630, rpm: 11.1 },
      { start: 71, end: 90, min: 665, rpm: 7.7 },
      { start: 91, end: 110, min: 695, rpm: 7.4 },
      { start: 111, end: 130, min: 820, rpm: 6.8 },
      { start: 131, end: 150, min: 880, rpm: 6.7 },
      { start: 151, end: 200, min: 1000, rpm: 6 },
      { start: 201, end: 250, min: 1200, rpm: 5.6 },
      { start: 251, end: 300, min: 1400, rpm: 5 },
      { start: 301, end: 350, min: 1500, rpm: 4.9 },
      { start: 351, end: 400, min: 1700, rpm: 4.7 },
      { start: 401, end: 450, min: 1900, rpm: 4.4 },
      { start: 451, end: 500, min: 2000, rpm: 4.2 },
      { start: 500, end: 99999, min: 2100, rpm: 4.2 },
    ],
  },
  longbeach: {
    name: 'Long Beach',
    address: '415 W. Ocean Blvd, Long Beach, CA 90802',
    lat: 33.7541833,
    lng: -118.2339676,
    coords: { lat: 33.7541833, lng: -118.2339676 },
    prices: [
      { start: 0, end: 10, min: 292.5, rpm: 35.9 },
      { start: 11, end: 20, min: 360, rpm: 23.9 },
      { start: 21, end: 30, min: 530, rpm: 18.6 },
      { start: 31, end: 40, min: 560, rpm: 15 },
      { start: 41, end: 50, min: 600, rpm: 12.6 },
      { start: 51, end: 70, min: 630, rpm: 11.1 },
      { start: 71, end: 90, min: 665, rpm: 7.7 },
      { start: 91, end: 110, min: 695, rpm: 7.4 },
      { start: 111, end: 130, min: 820, rpm: 6.8 },
      { start: 131, end: 150, min: 880, rpm: 6.7 },
      { start: 151, end: 200, min: 1000, rpm: 6 },
      { start: 201, end: 250, min: 1200, rpm: 5.6 },
      { start: 251, end: 300, min: 1400, rpm: 5 },
      { start: 301, end: 350, min: 1500, rpm: 4.9 },
      { start: 351, end: 400, min: 1700, rpm: 4.7 },
      { start: 401, end: 450, min: 1900, rpm: 4.4 },
      { start: 451, end: 500, min: 2000, rpm: 4.2 },
      { start: 500, end: 99999, min: 2100, rpm: 4.2 },
    ],
  },
  atlanta: {
    name: 'Atlanta',
    address: '6954 McLarin Road, Fairburn, GA 30213',
    lat: 33.5499313,
    lng: -84.6046571,
    coords: { lat: 33.5499313, lng: -84.6046571 },
    prices: [
      { start: 0, end: 10, min: 276, rpm: 33.9 },
      { start: 11, end: 20, min: 340, rpm: 22.5 },
      { start: 21, end: 30, min: 451, rpm: 15.8 },
      { start: 31, end: 40, min: 476, rpm: 12.7 },
      { start: 41, end: 50, min: 510, rpm: 10.7 },
      { start: 51, end: 70, min: 536, rpm: 9.4 },
      { start: 71, end: 90, min: 565, rpm: 6.6 },
      { start: 91, end: 110, min: 591, rpm: 6.3 },
      { start: 111, end: 130, min: 697, rpm: 6.4 },
      { start: 131, end: 150, min: 836, rpm: 6.3 },
      { start: 151, end: 200, min: 950, rpm: 5 },
      { start: 201, end: 250, min: 1000, rpm: 4.7 },
      { start: 251, end: 300, min: 1167, rpm: 4.2 },
      { start: 301, end: 350, min: 1250, rpm: 4 },
      { start: 351, end: 400, min: 1417, rpm: 4 },
      { start: 401, end: 450, min: 1583, rpm: 3.7 },
      { start: 451, end: 500, min: 1667, rpm: 3.5 },
      { start: 500, end: 99999, min: 1750, rpm: 3.5 },
    ],
  },
  baltimore: {
    name: 'Baltimore',
    address: '4801 Keith Ave Baltimore, MD 21224',
    lat: 39.2657334,
    lng: -76.5556285,
    coords: { lat: 39.2657334, lng: 76.5556285 },
    prices: [
      { start: 0, end: 10, min: 293, rpm: 35.9 },
      { start: 11, end: 20, min: 360, rpm: 23.8 },
      { start: 21, end: 30, min: 477, rpm: 16.8 },
      { start: 31, end: 40, min: 504, rpm: 13.5 },
      { start: 41, end: 50, min: 540, rpm: 11.3 },
      { start: 51, end: 70, min: 567, rpm: 10 },
      { start: 71, end: 90, min: 599, rpm: 7.8 },
      { start: 91, end: 110, min: 700, rpm: 7.5 },
      { start: 111, end: 130, min: 825, rpm: 7.2 },
      { start: 131, end: 150, min: 935, rpm: 7.1 },
      { start: 151, end: 200, min: 1062, rpm: 6.4 },
      { start: 201, end: 250, min: 1275, rpm: 5.9 },
      { start: 251, end: 300, min: 1487, rpm: 5.3 },
      { start: 301, end: 350, min: 1593, rpm: 5.2 },
      { start: 351, end: 400, min: 1806, rpm: 5 },
      { start: 401, end: 450, min: 2018, rpm: 4.7 },
      { start: 451, end: 500, min: 2125, rpm: 4.5 },
      { start: 500, end: 99999, min: 2231, rpm: 4.5 },
    ],
  },
  charleston: {
    name: 'Charleston',
    address: '2700 Bennett Yard Road, North Charleston, SC 29405',
    lat: 32.860216,
    lng: -80.0127275,
    coords: { lat: 32.860216, lng: -80.0127275 },
    prices: [
      { start: 0, end: 10, min: 296, rpm: 36.3 },
      { start: 11, end: 20, min: 364, rpm: 24.1 },
      { start: 21, end: 30, min: 483, rpm: 17 },
      { start: 31, end: 40, min: 510, rpm: 13.6 },
      { start: 41, end: 50, min: 546, rpm: 11.5 },
      { start: 51, end: 70, min: 574, rpm: 10.1 },
      { start: 71, end: 90, min: 606, rpm: 7 },
      { start: 91, end: 110, min: 633, rpm: 6.8 },
      { start: 111, end: 130, min: 747, rpm: 6.4 },
      { start: 131, end: 150, min: 827, rpm: 6.3 },
      { start: 151, end: 200, min: 940, rpm: 5.6 },
      { start: 201, end: 250, min: 1128, rpm: 5.3 },
      { start: 251, end: 300, min: 1316, rpm: 4.7 },
      { start: 301, end: 350, min: 1410, rpm: 4.6 },
      { start: 351, end: 400, min: 1598, rpm: 4.5 },
      { start: 401, end: 450, min: 1786, rpm: 4.2 },
      { start: 451, end: 500, min: 1880, rpm: 3.9 },
      { start: 500, end: 99999, min: 1974, rpm: 3.9 },
    ],
  },
  cincinnati: {
    name: 'Cincinnati',
    address: '2149 Western Avenue, Cincinnati, OH 45214',
    lat: 39.1211546,
    lng: -84.5408508,
    coords: { lat: 39.1211546, lng: -84.5408508 },
    prices: [
      { start: 0, end: 10, min: 276, rpm: 33.9 },
      { start: 11, end: 20, min: 340, rpm: 22.5 },
      { start: 21, end: 30, min: 451, rpm: 15.8 },
      { start: 31, end: 40, min: 476, rpm: 12.7 },
      { start: 41, end: 50, min: 510, rpm: 10.7 },
      { start: 51, end: 70, min: 536, rpm: 9.4 },
      { start: 71, end: 90, min: 565, rpm: 6.6 },
      { start: 91, end: 110, min: 591, rpm: 6.3 },
      { start: 111, end: 130, min: 697, rpm: 6.4 },
      { start: 131, end: 150, min: 836, rpm: 6.3 },
      { start: 151, end: 200, min: 950, rpm: 5 },
      { start: 201, end: 250, min: 1000, rpm: 4.7 },
      { start: 251, end: 300, min: 1167, rpm: 4.2 },
      { start: 301, end: 350, min: 1250, rpm: 4 },
      { start: 351, end: 400, min: 1417, rpm: 4 },
      { start: 401, end: 450, min: 1583, rpm: 3.7 },
      { start: 451, end: 500, min: 1667, rpm: 3.5 },
      { start: 500, end: 99999, min: 1750, rpm: 3.5 },
    ],
  },
  columbus: {
    name: 'Columbus',
    address: '2351 Westbelt Dr, Columbus, OH 43228, USA',
    lat: 40.0014156,
    lng: -83.1267939,
    coords: { lat: 40.0014156, lng: -83.1267939 },
    prices: [
      { start: 0, end: 10, min: 276, rpm: 33.9 },
      { start: 11, end: 20, min: 340, rpm: 22.5 },
      { start: 21, end: 30, min: 451, rpm: 15.8 },
      { start: 31, end: 40, min: 476, rpm: 12.7 },
      { start: 41, end: 50, min: 510, rpm: 10.7 },
      { start: 51, end: 70, min: 536, rpm: 9.4 },
      { start: 71, end: 90, min: 565, rpm: 6.6 },
      { start: 91, end: 110, min: 591, rpm: 6.3 },
      { start: 111, end: 130, min: 697, rpm: 6.4 },
      { start: 131, end: 150, min: 836, rpm: 6.3 },
      { start: 151, end: 200, min: 950, rpm: 5 },
      { start: 201, end: 250, min: 1000, rpm: 4.7 },
      { start: 251, end: 300, min: 1167, rpm: 4.2 },
      { start: 301, end: 350, min: 1250, rpm: 4 },
      { start: 351, end: 400, min: 1417, rpm: 4 },
      { start: 401, end: 450, min: 1583, rpm: 3.7 },
      { start: 451, end: 500, min: 1667, rpm: 3.5 },
      { start: 500, end: 99999, min: 1750, rpm: 3.5 },
    ],
  },
  dallas: {
    name: 'Dallas',
    address: '1111 Intermodal Parkway, Haslet, TX 76052',
    lat: 32.9900415,
    lng: -97.3496222,
    coords: { lat: 32.9900415, lng: -97.3496222 },
    prices: [
      { start: 0, end: 10, min: 302, rpm: 37.1 },
      { start: 11, end: 20, min: 372, rpm: 24.6 },
      { start: 21, end: 30, min: 493, rpm: 17.3 },
      { start: 31, end: 40, min: 521, rpm: 13.9 },
      { start: 41, end: 50, min: 558, rpm: 11.7 },
      { start: 51, end: 70, min: 586, rpm: 10.3 },
      { start: 71, end: 90, min: 618, rpm: 7.2 },
      { start: 91, end: 110, min: 646, rpm: 6.9 },
      { start: 111, end: 130, min: 763, rpm: 6.6 },
      { start: 131, end: 150, min: 862, rpm: 6.5 },
      { start: 151, end: 200, min: 980, rpm: 5.9 },
      { start: 201, end: 250, min: 1176, rpm: 5.5 },
      { start: 251, end: 300, min: 1372, rpm: 4.9 },
      { start: 301, end: 350, min: 1470, rpm: 4.8 },
      { start: 351, end: 400, min: 1666, rpm: 4.7 },
      { start: 401, end: 450, min: 1862, rpm: 4.4 },
      { start: 451, end: 500, min: 1960, rpm: 4.1 },
      { start: 500, end: 99999, min: 2058, rpm: 4.1 },
    ],
  },
  jacksonville: {
    name: 'Jacksonville',
    address: '5902 Sportsman Club Road, Jacksonville, FL 32219',
    lat: 30.3832357,
    lng: -81.767229,
    coords: { lat: 30.3832357, lng: -81.767229 },
    prices: [
      { start: 0, end: 10, min: 276, rpm: 33.9 },
      { start: 11, end: 20, min: 340, rpm: 19.2 },
      { start: 21, end: 30, min: 384, rpm: 13.5 },
      { start: 31, end: 40, min: 406, rpm: 10.9 },
      { start: 41, end: 50, min: 435, rpm: 9.1 },
      { start: 51, end: 70, min: 457, rpm: 8 },
      { start: 71, end: 90, min: 482, rpm: 5.6 },
      { start: 91, end: 110, min: 504, rpm: 5.4 },
      { start: 111, end: 130, min: 594, rpm: 5.2 },
      { start: 131, end: 150, min: 675, rpm: 5.1 },
      { start: 151, end: 200, min: 767, rpm: 4.6 },
      { start: 201, end: 250, min: 920, rpm: 4.3 },
      { start: 251, end: 300, min: 1074, rpm: 3.8 },
      { start: 301, end: 350, min: 1151, rpm: 3.7 },
      { start: 351, end: 400, min: 1304, rpm: 3.6 },
      { start: 401, end: 450, min: 1457, rpm: 3.4 },
      { start: 451, end: 500, min: 1534, rpm: 3.2 },
      { start: 500, end: 99999, min: 1611, rpm: 3.2 },
    ],
  },
  oakland: {
    name: 'Oakland',
    address: '2800 7th Street, Oakland, CA 94607',
    lat: 37.8073947,
    lng: -122.3273623,
    coords: { lat: 37.8073947, lng: -122.3273623 },
    prices: [
      { start: 0, end: 10, min: 341, rpm: 41.9 },
      { start: 11, end: 20, min: 420, rpm: 27.8 },
      { start: 21, end: 30, min: 557, rpm: 19.6 },
      { start: 31, end: 40, min: 588, rpm: 15.7 },
      { start: 41, end: 50, min: 630, rpm: 13.2 },
      { start: 51, end: 70, min: 662, rpm: 11.6 },
      { start: 71, end: 90, min: 698, rpm: 8.1 },
      { start: 91, end: 110, min: 730, rpm: 7.8 },
      { start: 111, end: 130, min: 861, rpm: 7.1 },
      { start: 131, end: 150, min: 924, rpm: 7 },
      { start: 151, end: 200, min: 1050, rpm: 6.3 },
      { start: 201, end: 250, min: 1260, rpm: 5.9 },
      { start: 251, end: 300, min: 1470, rpm: 5.2 },
      { start: 301, end: 350, min: 1575, rpm: 5.1 },
      { start: 351, end: 400, min: 1785, rpm: 5 },
      { start: 401, end: 450, min: 1995, rpm: 4.7 },
      { start: 451, end: 500, min: 2100, rpm: 4.4 },
      { start: 500, end: 99999, min: 2205, rpm: 4.4 },
    ],
  },
  phoenix: {
    name: 'Phoenix',
    address: '5281 North Tom Murray Avenue, Glendale, AZ 85301',
    lat: 33.5151418,
    lng: -112.162419,
    coords: { lat: 33.5151418, lng: -112.162419 },
    prices: [
      { start: 0, end: 10, min: 341, rpm: 41.9 },
      { start: 11, end: 20, min: 420, rpm: 27.8 },
      { start: 21, end: 30, min: 557, rpm: 19.6 },
      { start: 31, end: 40, min: 588, rpm: 15.7 },
      { start: 41, end: 50, min: 630, rpm: 13.2 },
      { start: 51, end: 70, min: 662, rpm: 11.6 },
      { start: 71, end: 90, min: 698, rpm: 8.1 },
      { start: 91, end: 110, min: 730, rpm: 7.8 },
      { start: 111, end: 130, min: 861, rpm: 7.1 },
      { start: 131, end: 150, min: 924, rpm: 7 },
      { start: 151, end: 200, min: 1050, rpm: 6.3 },
      { start: 201, end: 250, min: 1260, rpm: 5.9 },
      { start: 251, end: 300, min: 1470, rpm: 5.2 },
      { start: 301, end: 350, min: 1575, rpm: 5.1 },
      { start: 351, end: 400, min: 1785, rpm: 5 },
      { start: 401, end: 450, min: 1995, rpm: 4.7 },
      { start: 451, end: 500, min: 2100, rpm: 4.4 },
      { start: 500, end: 99999, min: 2205, rpm: 4.4 },
    ],
  },
  wilmington: {
    name: 'Wilmington',
    address: '1 Shipyard Blvd, Wilmington, NC 28412',
    lat: 34.1921234,
    lng: -77.9499728,
    coords: { lat: 34.1921234, lng: -77.9499728 },
    prices: [
      { start: 0, end: 10, min: 260, rpm: 31.9 },
      { start: 11, end: 20, min: 320, rpm: 18 },
      { start: 21, end: 30, min: 361, rpm: 12.7 },
      { start: 31, end: 40, min: 381, rpm: 10.2 },
      { start: 41, end: 50, min: 408, rpm: 8.6 },
      { start: 51, end: 70, min: 429, rpm: 7.5 },
      { start: 71, end: 90, min: 452, rpm: 5.2 },
      { start: 91, end: 110, min: 473, rpm: 5.7 },
      { start: 111, end: 130, min: 625, rpm: 5.2 },
      { start: 131, end: 150, min: 673, rpm: 5.1 },
      { start: 151, end: 200, min: 765, rpm: 4.6 },
      { start: 201, end: 250, min: 918, rpm: 4.3 },
      { start: 251, end: 300, min: 1071, rpm: 3.8 },
      { start: 301, end: 350, min: 1148, rpm: 3.7 },
      { start: 351, end: 400, min: 1301, rpm: 3.6 },
      { start: 401, end: 450, min: 1454, rpm: 3.4 },
      { start: 451, end: 500, min: 1531, rpm: 3.2 },
      { start: 500, end: 99999, min: 1607, rpm: 3.2 },
    ],
  },
  philadelphia: {
    name: 'Philadelphia',
    address: 'Packer Ave & S Christopher Columbus Blvd, Philadelphia, PA 19148',
    lat: 39.9074043,
    lng: -75.1415806,
    coords: {
      lat: 39.9074043,
      lng: -75.1415806,
    },
    prices: [
      { start: 0, end: 10, min: 294, rpm: 36.1 },
      { start: 11, end: 20, min: 305, rpm: 20.2 },
      { start: 21, end: 30, min: 469, rpm: 16.5 },
      { start: 31, end: 40, min: 390, rpm: 10.4 },
      { start: 41, end: 50, min: 509, rpm: 10.6 },
      { start: 51, end: 70, min: 525, rpm: 9.3 },
      { start: 71, end: 90, min: 537, rpm: 6.2 },
      { start: 91, end: 110, min: 559, rpm: 6 },
      { start: 111, end: 130, min: 571, rpm: 5 },
      { start: 131, end: 150, min: 576, rpm: 4.3 },
      { start: 151, end: 200, min: 622, rpm: 3.7 },
      { start: 201, end: 250, min: 670, rpm: 3.1 },
      { start: 251, end: 300, min: 718, rpm: 2.6 },
      { start: 301, end: 350, min: 839.5, rpm: 2.7 },
      { start: 351, end: 400, min: 961, rpm: 2.7 },
      { start: 401, end: 450, min: 1074, rpm: 2.5 },
      { start: 451, end: 500, min: 1215, rpm: 2.5 },
      { start: 500, end: 99999, min: 1356, rpm: 2.5 },
    ],
  },
};
